
const SOURCE_MANUAL = 'MANUAL';
const SOURCE_IOT = 'IOT';
const SOURCE_CONTROLLER = 'CONTROLLER';

const TYPE_MAKE_UP = 'MAKEUP';
const TYPE_BLOWDOWN = 'BLOWDOWN';
const TYPE_FEED = 'FEED';
const TYPE_STEAM = 'STEAM';
const TYPE_CONDENSATE = 'CONDENSATE';

const FLOW_METERS_DATA_SOURCE = [SOURCE_MANUAL, SOURCE_IOT, SOURCE_CONTROLLER];
const FLOW_METERS_TYPE = [TYPE_MAKE_UP, TYPE_BLOWDOWN, TYPE_FEED, TYPE_STEAM, TYPE_CONDENSATE];
module.exports = {
    FLOW_METERS_DATA_SOURCE,
    FLOW_METERS_TYPE,
    SOURCE_MANUAL,
    SOURCE_IOT,
    SOURCE_CONTROLLER,
    TYPE_MAKE_UP,
    TYPE_BLOWDOWN,
    TYPE_FEED,
    TYPE_STEAM,
    TYPE_CONDENSATE,
};

